import { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { supabase } from '../lib/supabase';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function formatDataPrevista(data) {
  if (!data) return '—';
  const d = new Date(data.length === 10 ? data + 'T12:00:00' : data);
  return isNaN(d.getTime()) ? '—' : format(d, 'd/MM/yyyy');
}

export default function DashboardPage() {
  const { profile } = useAuth();
  const [stats, setStats] = useState({ pacientes: 0, pesquisas: 0, retornos: 0 });
  const [proximosRetornos, setProximosRetornos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const [pac, pes, agenda] = await Promise.all([
        supabase.from('pacientes').select('id', { count: 'exact', head: true }),
        supabase.from('pesquisas').select('id', { count: 'exact', head: true }).eq('ativa', true),
        supabase.from('agenda_retornos')
          .select('id, data_prevista, pesquisa_paciente_id(paciente_id(iniciais, prontuario))')
          .is('data_realizada', null)
          .gte('data_prevista', new Date().toISOString().split('T')[0])
          .order('data_prevista')
          .limit(5)
      ]);
      setStats({
        pacientes: pac.count || 0,
        pesquisas: pes.count || 0,
        retornos: agenda.data?.length || 0
      });
      setProximosRetornos(agenda.data || []);
      setLoading(false);
    }
    load();
  }, []);

  const hora = new Date().getHours();
  const saudacao = hora < 12 ? 'Bom dia' : hora < 18 ? 'Boa tarde' : 'Boa noite';
  const nome = profile?.nome_completo?.split(' ')[0] || 'Pesquisador';

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>{saudacao}, Dr. {nome}</h1>
          <p>Visão geral do sistema · {format(new Date(), "EEEE, d 'de' MMMM", { locale: ptBR })}</p>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="icon-wrap">🧑‍⚕️</div>
          <div className="label">Pacientes cadastrados</div>
          <div className="value">{loading ? '—' : stats.pacientes}</div>
        </div>
        <div className="stat-card">
          <div className="icon-wrap">🔬</div>
          <div className="label">Pesquisas ativas</div>
          <div className="value">{loading ? '—' : stats.pesquisas}</div>
        </div>
        <div className="stat-card">
          <div className="icon-wrap">📅</div>
          <div className="label">Retornos pendentes</div>
          <div className="value">{loading ? '—' : stats.retornos}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>📅 Próximos retornos</h2>
        </div>
        <div className="card-body">
          {loading ? (
            <p className="text-muted text-sm">Carregando...</p>
          ) : proximosRetornos.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">✅</div>
              <h3>Nenhum retorno pendente</h3>
              <p>Todos os retornos próximos estão em dia.</p>
            </div>
          ) : (
            <div className="table-wrap">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {proximosRetornos.map(r => (
                  <div key={r.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: 'var(--bg)', borderRadius: 8, border: '1px solid var(--border)' }}>
                    <div>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{r.pesquisa_paciente_id?.paciente_id?.iniciais || '—'}</span>
                      <span className="mono text-muted" style={{ fontSize: 12, marginLeft: 8 }}>{r.pesquisa_paciente_id?.paciente_id?.prontuario || '—'}</span>
                    </div>
                    <span className="text-sm text-muted">{formatDataPrevista(r.data_prevista)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
